import React from 'react';
import { makeStyles } from '~/UIKit/Style';
import { Dots } from '~/UIKit';
import { USCConnected, USCTransmitting } from '~/Components/Icons';

export const styles = makeStyles(() => ({
  icon: {
    '&.MuiSvgIcon-root': {
      width: 49,
      height: 49,
      margin: '-20px 0',
    },
  },
}));

export const USCIntegrationStatus = ({
  isLoading,
  isIntegrated,
}: {
  isLoading: boolean;
  isIntegrated: boolean;
}) => {
  const { classes } = styles();

  if (isLoading) {
    return <Dots />;
  }

  return isIntegrated ? (
    <USCConnected className={classes.icon} />
  ) : (
    <USCTransmitting className={classes.icon} />
  );
};
